<template>

  <div class="wrapper">

    <v-row no-gutters class="box">
      <img :style="`margin-top: 40px; width: ${localConfig.logo && localConfig.logo.tamanho}%`" :src="localConfig.logo && localConfig.logo.img" alt="">
      <h1 style="text-align: center; font-weight: 500; font-size: 28px">{{localConfig.logo && localConfig.logo.titulo}}</h1>
      <p v-if="!isLoading">Sua mensagem foi enviada com sucesso, responderemos assim que possivel.</p>
      <v-progress-circular v-if="isLoading" width="5" :size="55" class="loading" indeterminate></v-progress-circular>
      <p v-if="isLoading">Enviando sua mensagem.</p>
      <v-row justify="center">
        <v-icon v-if="!isLoading" style="main-icon" size="60" color="primary">mdi-checkbox-marked-circle-outline</v-icon>
      </v-row>
      <br>
      <v-btn v-if="!isLoading" block color="primary" @click="backtoForm">
        Voltar para o formulário
      </v-btn>
    </v-row>

  </div>
</template>

<script>
export default {
    name: "Room",
    data: () => ({
      name: null,
      isLoading: true,
      localConfig: {},
    }),
    mounted(){

      this.localConfig = JSON.parse(localStorage.getItem('@bsi:config'));

      const { name } = this.$route.params;

      setTimeout(() => {
        this.isLoading = false;
      }, 1000);

      console.log(name);
    },
    methods: {

      backtoForm(){
          const { roomID } = this.$route.params;
          this.$router.push({name: 'Signin' });
      }
      
    }
}
</script>

<style lang="scss" scoped>

  .wrapper{
    background-color: var(--v-secondary-base);

    .box{

      .v-btn{
        color: #272727;
        .v-progress-circular{
          margin-right: 10px;
        }
      }

      .main-icon{
        display: block;
        margin: 0 auto;
      }

      width: 25vw;
      min-width: 300px;
      display: block;
      padding: 40px 20px;

      .name{
        color: var(--v-primary-base);
        font-weight: bold;
      }
      h3{
        font-size: 26px;
        font-weight: 400;
        text-align: center;
      }
      p{
        font-size: 14px;
        text-align: center;
        padding: 20px 0;
        margin: 0;
      }
      .loading{
        display: block;
        margin: 0 auto;
      }
      img{
        display: block;
        margin: 20px auto;
      }

    }
   
  }

  @media screen and (max-width: 900px) {
    .container{
      margin: 10px;
    }
   
  }

</style>